import React from "react";

const IconImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#1A1A1A"
        d="M11.25 13.688h-1.5a.563.563 0 00-.563.562v5.25a.562.562 0 101.126 0v-.938h.937a2.438 2.438 0 100-4.875zm0 3.75h-.938v-2.625h.938a1.313 1.313 0 010 2.624zm8.813-.188v1.582a.562.562 0 01-.157.389 2.632 2.632 0 01-1.906.841c-1.55 0-2.813-1.43-2.813-3.187 0-1.758 1.262-3.188 2.813-3.188a2.571 2.571 0 011.44.448.563.563 0 11-.63.933 1.43 1.43 0 00-.81-.255c-.93 0-1.688.925-1.688 2.062 0 1.137.757 2.063 1.688 2.063.344-.004.675-.128.938-.35v-.776h-.188a.562.562 0 110-1.125h.75a.562.562 0 01.563.563zm-12.75-3v3.563a2.25 2.25 0 01-4.5 0 .562.562 0 111.124 0 1.125 1.125 0 002.25 0V14.25a.562.562 0 111.125 0zm12.585-6.397l-5.25-5.25a.563.563 0 00-.398-.166h-9A1.313 1.313 0 003.937 3.75v6.75a.562.562 0 101.126 0V3.75a.187.187 0 01.187-.188h8.438V8.25a.563.563 0 00.562.563h4.688V10.5a.562.562 0 101.125 0V8.25c0-.15-.06-.292-.165-.397zm-5.085-.165v-3.33l3.33 3.33h-3.33z"
      ></path>
    </svg>
  );
}

export default IconImage;
